import { MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { Component, ElementRef, Inject, NgModule, ViewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { QRCodeComponent } from 'angularx-qrcode';

interface QrCodeConfig {
  link: string;
  title: string;
  message: string;
}

@Component({
    selector: 'ts-qr-code',
    templateUrl: './qr-code.component.html',
    styleUrls: ['./qr-code.component.scss'],
    standalone: false
})
export class QrCodeComponent {

  @ViewChild('qr', { read: ElementRef }) qrElement: ElementRef<HTMLElement>;

  constructor(@Inject(MAT_DIALOG_DATA) public readonly data: QrCodeConfig) { }

  public getQRDownloadURL() {
    return this.qrElement?.nativeElement.querySelector('img')?.getAttribute('src');
  }
}

@NgModule({
  imports: [CommonModule, MatDialogModule, TranslateModule, QRCodeComponent],
  declarations: [QrCodeComponent],
  exports: [QrCodeComponent],
})
export class QrCodeComponentModule { }
